import styled from "styled-components";
export const SummaryContainer = styled.div`
  display: inline-block;
  margin: 16px 0;
`;
export const SummaryRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
export const Title = styled.span`
  font-weight: bold;
  min-width: 180px;
`;
export const Value = styled.span`
  padding: 6px 10px;
  width: 100%;
  min-width: 130px;
`;
